<div class="row h-100">
  <div class="view h-100">
    <img class="d-block h-100" src="assets/img/news_events_1.png">
    <div class="mask rgba-black-slight"></div>
  </div>

  <div class="carousel-caption fund-caption">
    <div *ngIf="!peerAnalysis" class="col-12 py-1 px-3 h-100 text-white text-center" style="background: rgba(255, 255, 255, 0.90)"></div>
    <div *ngIf="peerAnalysis" class="col-12 py-1 px-3 h-100 text-white text-center" style="background: rgba(0, 0, 0, 0.75)">
      <app-title [title]="peerAnalysis.name" priority="4" [uppercase]="false"></app-title>

      <div class="row mt-5">
        <div class="col"><hr></div>
        <div class="text-center" style="line-height:33px">Performance - Risk</div>
        <div class="col"><hr></div>
      </div>

      <div class="row">
        <div class="col-3" style="line-height:1">
            <span style="color:rgb(118,168,255)">
                <br/>Returns
            </span>
        </div>
        <div class="col-3" style="line-height:1">
            <span style="color:rgb(118,168,255)">
              <br/>Volatility
            </span>
        </div>
        <div class="col-3" style="line-height:1">
            <span style="color:rgb(118,168,255)">
                <br/>Sharpe ratio
            </span>
        </div>
        <div class="col-3" style="line-height:1">
            <span style="color:rgb(118,168,255)">
                Max<br/>Drawdown
            </span>
        </div>
      </div>

      <div class="row mt-2 mb-3">
        <div class="col-3" style="line-height:1">
          <span style="font-size:1.1em;">{{ peerAnalysis.returns | percent:'.1' }}</span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="font-size:1.1em;">{{ peerAnalysis.volatility | percent:'.1' }}</span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="font-size:1.1em;">{{ peerAnalysis.sharpe_ratio | number:'.2' }}</span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="font-size:1.1em;">{{ peerAnalysis.maximum_drawdown | percent:'.1' }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-3" style="line-height:1">
          <span style="color:rgb(118,168,255)">
            Excess<br/>Returns
          </span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="color:rgb(118,168,255)">
            Tracking<br/>Error
          </span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="color:rgb(118,168,255)">
            Information<br/>ratio
          </span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="color:rgb(118,168,255)">
            Max Relative<br/>Drawdown
          </span>
        </div>
      </div>

      <div class="row mt-2 mb-2">
        <div class="col-3" style="line-height:1">
          <span style="font-size:1.1em;">{{ peerAnalysis.excess_returns | percent:'.1' }}</span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="font-size:1.1em;">{{ peerAnalysis.tracking_error | percent:'.1' }}</span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="font-size:1.1em;">{{ peerAnalysis.information_ratio | number:'.2' }}</span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="font-size:1.1em;">{{ peerAnalysis.maximum_relative_drawdown | percent:'.1' }}</span>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col"><hr></div>
        <div class="text-center" style="line-height:33px">Factor Analysis</div>
        <div class="col"><hr></div>
      </div>

      <div class="row">
        <div class="col-3" style="line-height:1">
          <span style="color:rgb(118,168,255)">
            <br/>Market<br/>Exposure
          </span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="color:rgb(118,168,255)">
            <br/>Factor<br/>Intensity
          </span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="color:rgb(118,168,255)">
            Effective<br/>Number<br/>of Factors
          </span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="color:rgb(118,168,255)">
            <br/>Deconcentration<br/>Rating
          </span>
        </div>
      </div>

      <div class="row mt-2 mb-2">
        <div class="col-3" style="line-height:1">
          <span style="font-size:1.1em;">{{ peerAnalysis.market_exposure | number:'.2' }}</span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="font-size:1.1em;">{{ peerAnalysis.factor_intensity | number:'.2' }}</span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="font-size:1.1em;">{{ peerAnalysis.effective_nb_of_factors | number:'.2' }}</span>
        </div>
        <div class="col-3 rating" style="line-height:1">
          <app-rating-span [rating]="peerAnalysis.factor_deconcentration_quality_rating"></app-rating-span>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col"><hr></div>
        <div class="text-center" style="line-height:33px">Robustness</div>
        <div class="col"><hr></div>
      </div>

      <div class="row">
        <div class="col-3" style="line-height:1">
          <span style="color:rgb(118,168,255)">
            Conditional<br/>Performance
          </span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="color:rgb(118,168,255)">
            Rolling Risk<br/>Statistics
          </span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="color:rgb(118,168,255)">
            Outperformance<br/>Probability
          </span>
        </div>
        <div class="col-3" style="line-height:1">
          <span style="color:rgb(118,168,255)">
            Global<br/>Rating
          </span>
        </div>
      </div>

      <div class="row mt-2 mb-2">
        <div class="col-3 rating" style="line-height:1">
          <app-rating-span [rating]="peerAnalysis.conditional_performance_rating"></app-rating-span>
        </div>
        <div class="col-3 rating" style="line-height:1">
          <app-rating-span [rating]="peerAnalysis.worst_rolling_risk_statistics_rating"></app-rating-span>
        </div>
        <div class="col-3 rating" style="line-height:1">
          <app-rating-span [rating]="peerAnalysis.outperformance_probability_rating"></app-rating-span>
        </div>
        <div class="col-3 rating" style="line-height:1">
          <app-rating-span [rating]="peerAnalysis.global_robustness_rating"></app-rating-span>
        </div>
      </div>

      <div class="w-100 mt-3">
        <em class="float-right" style="font-size:0.7em">
          {{ peerAnalysis.inception_date | date:'MMMM d, y' }} — {{ peerAnalysis.last_date | date:'MMMM d, y' }}
        </em>
      </div>

    </div>
  </div>
</div>
